
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import './ProgramFeedbacks.scss';
import moment from 'moment';
import { format, isValid } from 'date-fns';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import {FormGroup, Label} from "reactstrap";
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { CircularProgress } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import {stableSort, rowOptions, getComparator} from '../../../utils/Helper'
import * as routes from "../../../Router/RoutesURL";
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {getProgramFeedbackListAction} from '../../../redux/actions/ReportAction/ProgramFeedbackAction/ProgramFeedbackAction'
import DatePicker from '../../../components/DatePicker/DatePicker';
import { tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    {
        id: 'title',
        disablePadding: true,
        label: 'PROGRAM TITLE',
        disableSorting: false,
    },
    {
        id: 'guest_name',
        disablePadding: false,
        label: 'GUEST NAME',
        disableSorting: false,
    },
    {
        id: 'check_in',
        disablePadding: false,
        label: 'CHECK IN / CHECK OUT',
        disableSorting: false,
    },
    {
        id: 'submitted_on',
        disablePadding: false,
        label: 'SUBMITTED ON',
        disableSorting: false,
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { setShowLoader, activeTab } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const [fromDate, setFromDate] = useState(searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState(searchParams.get('filter_to') || moment().format('YYYY-MM-DD'));

    useEffect(() => {
        if (activeTab == tabKeys.reports.PROGRAM_FEEDBACK) {
            setSearchText(searchParams.get('filter_text') || '');
            setFromDate(searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'));
            setToDate(searchParams.get('filter_to') || moment().format('YYYY-MM-DD'));
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        setShowLoader(true);
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeFromDate = (val) => {
        setShowLoader(true);
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setFromDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('filter_from', formattedDate);
        } else {
            newParams.delete('filter_from');
            newParams.delete('filter_to');
            setToDate('');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        setShowLoader(true);
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setToDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('filter_to', formattedDate);
        } else {
            newParams.delete('filter_to');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Program Feedbacks List
                    </MainHeading>
                </div>
                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-9 col-xxl-9 LevelDiv'>
                    <div className='DurationDiv d-flex align-items-center'>
                        <Label>Date:</Label>
                        <DatePicker
                            onChange={date => { changeFromDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={isValid(new Date(fromDate)) ? new Date(moment(fromDate, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                        <div className='mx-2'>to</div>
                        <DatePicker
                            onChange={date => { changeToDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={isValid(new Date(toDate)) ? new Date(moment(toDate, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                            minDate={fromDate ? new Date((moment(fromDate, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY')) : null}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                    </div>
                    <div className="separator"></div>

                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            value={searchText}
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}


const ProgramFeedbacksTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type'));
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by'));
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [getProgramFeedbackListMainData, setgetProgramFeedbackListMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate()
    const getProgramFeedbackList = useSelector(state => state?.getProgramFeedbackList);
    const getProgramFeedbackListDataRes = useSelector(state => state?.getProgramFeedbackList?.getProgramFeedbackList);
    const { activeTab } = props;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!getProgramFeedbackList.loading)
            setShowLoader(false)
        if(!getProgramFeedbackList.loading && !getProgramFeedbackListDataRes?.data?.data && !getProgramFeedbackList.error){
            setShowLoader(true)
        }
    }, [getProgramFeedbackList.loading])

    useEffect(() => {
        if (activeTab == tabKeys.reports.PROGRAM_FEEDBACK) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '' ,
                "filter_from": searchParams.get('filter_from') || moment().startOf('month').format('YYYY-MM-DD'),
                "filter_to": searchParams.get('filter_to') || moment().format('YYYY-MM-DD'),
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || ''
            };
            dispatch(getProgramFeedbackListAction(sendRequest));
        }else{
          setOrder('');
          setOrderBy('');
          setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (getProgramFeedbackList.error !== "Ananda program feedback data does not exists") {
            setgetProgramFeedbackListMainData(getProgramFeedbackListDataRes && getProgramFeedbackListDataRes?.data?.data);
        } else {
            setgetProgramFeedbackListMainData('');
        }
    }, [getProgramFeedbackListDataRes, getProgramFeedbackList])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = getProgramFeedbackListDataRes && getProgramFeedbackListMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = (newPage) => {
        setShowLoader(true);
        const nextPage = (getProgramFeedbackListDataRes?.data?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    
    const handleChangePagePrev = (newPage) => {
        setShowLoader(true);
        const prevPage = (getProgramFeedbackListDataRes?.data?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true);
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('limit', newRowsPerPage.toString());
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleViewProgramFeedback = (data) => {
        navigate(routes.VIEW_PROGRAM_FEEDBACK, { state: { data } })
    };

    return (
    <Box sx={{ width: '100%' }} className="ProgramFeedbackBox h-100">
      <Paper  className='d-flex flex-column'sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
        <EnhancedTableToolbar showLoader={showLoader} setShowLoader={setShowLoader} activeTab={activeTab} />
        {
          showLoader ?
            <div className='w-100 text-center py-5'>
              <CircularProgress sx={{ 'color': '#74613C' }} />
            </div>
            :
            <>

              {getProgramFeedbackListMainData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  stickyHeader
                  size='small'
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort} // This can be removed if sorting is not needed
                    rowCount={getProgramFeedbackListDataRes && getProgramFeedbackListMainData?.length}
                  />
                  <TableBody>
                    {
                      getProgramFeedbackListDataRes && stableSort(getProgramFeedbackListMainData, getComparator(order, orderBy))
                        .map((row, index) => {
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <React.Fragment key={index}>
                              <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"

                                tabIndex={-1}

                                key={index}

                              >
                                <TableCell component="th" id={labelId} scope="row" padding="none" width={'30%'}>{row.title}</TableCell>
                                <TableCell align="left">{row.guest_name}</TableCell>
                                <TableCell align="left">
                                  {row.check_in ? moment(row.check_in).format('DD/MM/YYYY') : ''} - {row.check_out ? moment(row.check_out).format('DD/MM/YYYY') : ''}
                                </TableCell>
                                <TableCell align="left">{row.submitted_on ? moment(row.submitted_on).format('DD/MM/YYYY') : ''}</TableCell>

                                <TableCell align="left"
                                  className=' ViewEditClick '
                                  onClick={() => { handleViewProgramFeedback(row) }}><i className="fas fa-eye mr-2"></i>View</TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
              : <div className='text-center w-100 text-muted mt-3'>No Records</div>
              }
            </>
        }
      </Paper>
      {
        getProgramFeedbackListMainData
        &&
        <div className='paginationBlock'>
          <div className='textData'><p>Items per page: </p></div>
          <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
            <Select
              placeholder={rowsPerPage}
              className="react-select"
              classNamePrefix="react-select"
              value={rowsPerPage}
              options={rowOptions}
              isSearchable={false}
              onChange={handleChangeRowsPerPage}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#F5F5F5',
                  primary: '#74613C',
                },
              })}
              menuPlacement="top"
              menuPosition="fixed"
              styles={{
                menu: (base) => ({
                  ...base,
                  top: 'auto',
                  bottom: 0,
                }),
              }}
            />
          </FormGroup>
          {getProgramFeedbackListDataRes?.data && <p className='endText'>   {getProgramFeedbackListDataRes?.data?.start} - {getProgramFeedbackListDataRes?.data?.end} of {getProgramFeedbackListDataRes?.data?.total}</p>}
          <p>                         
            <button className={`btnPrev ${getProgramFeedbackListDataRes?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={getProgramFeedbackListDataRes?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                <ArrowBackIosNewSharpIcon className='iconBtn' />
            </button> 
            <button className={`btnPrev ${getProgramFeedbackListDataRes?.data?.current_page_no === getProgramFeedbackListDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={getProgramFeedbackListDataRes?.data?.current_page_no === getProgramFeedbackListDataRes?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                <ArrowForwardIosSharpIcon className='iconBtn' />
            </button></p>
        </div>
      }
    </Box>
    );
}
export default ProgramFeedbacksTable;